import { Link } from "react-router-dom";

/**
 * Public footer. Every link here resolves to a real destination — dead links on
 * an acquisition page cost more trust than a missing section does.
 */
const COLUMNS = [
  {
    heading: "For communities",
    links: [
      { label: "Register your community", to: "/signup" },
      { label: "What you'd earn", to: "/calculator#estimate" },
      { label: "How it works", to: "/#earnings" },
      { label: "Sign in", to: "/login" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Terms of service", to: "/terms" },
      { label: "Privacy policy", to: "/privacy" },
    ],
  },
];

const CONTACT = [
  { label: "info@weshoup.com", href: "mailto:info@weshoup.com" },
  { label: "9833080782", href: "tel:+919833080782" },
];

function Footer() {
  return (
    <footer className="bg-[hsl(240_17%_8%)] text-white">
      <div className="container mx-auto px-4 py-14 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {COLUMNS.map(({ heading, links }) => (
            <div key={heading}>
              <h4 className="mb-4 text-xs font-semibold uppercase tracking-wider text-white/40">
                {heading}
              </h4>
              <ul className="space-y-3 text-sm">
                {links.map(({ label, to }) => (
                  <li key={label}>
                    <Link
                      to={to}
                      className="text-white/60 transition-colors hover:text-white"
                    >
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-wider text-white/40">
              Talk to us
            </h4>
            <ul className="space-y-3 text-sm">
              {CONTACT.map(({ label, href }) => (
                <li key={label}>
                  <a
                    href={href}
                    className="text-white/60 transition-colors hover:text-white"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-wider text-white/40">
              Home for the physically active
            </h4>
            <p className="text-sm italic leading-relaxed text-[hsl(var(--brand-lavender))]">
              Participation is the currency.
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 md:flex-row">
          <div className="flex items-center space-x-2">
            <img src="/shoup.svg" alt="ShoUp" className="h-6 w-6 rounded" />
            <span className="text-sm font-bold">ShoUp</span>
          </div>
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} ShoUp. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
